// extracted by mini-css-extract-plugin
export default {"sidebar":"ConfigurationSidebar_sidebar__qnjvm","sidebar__wrapper":"ConfigurationSidebar_sidebar__wrapper__ciWQc","sidebar__support":"ConfigurationSidebar_sidebar__support__NoKRI"};